import React from 'react';
import { C, S } from '../../utils/styles';
import { fmt } from '../../utils/formatters';

export default function IBOSSummary({ aggregates, companyName, employeeCount }) {
  const total = aggregates?.total || 0;
  const empr = aggregates?.employerSavings || 0;
  const emp = aggregates?.employeeValue || 0;
  const hc = aggregates?.healthcareImpact || 0;

  return (
    <div
      data-testid="ibos-summary"
      style={{
        ...S.card,
        background: `linear-gradient(135deg, ${C.accentBg} 0%, ${C.card} 100%)`,
        border: `1px solid ${C.accentLight}`,
        padding: '28px 32px',
      }}
    >
      <div style={{ fontSize: 10, fontWeight: 700, color: C.accent, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 6 }}>
        Integrated Benefits Optimization Strategy
      </div>
      {companyName && (
        <div style={{ fontSize: 13, color: C.textMid, marginBottom: 16 }}>
          {companyName} · {employeeCount} employees
        </div>
      )}

      <div style={{ fontSize: 11, fontWeight: 700, color: C.textLight, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 8 }}>
        Total Annual Optimization Opportunity
      </div>

      <div
        data-testid="ibos-total-value"
        style={{
          fontSize: 44,
          fontWeight: 800,
          color: C.accent,
          letterSpacing: '-0.02em',
          margin: '4px 0 20px',
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        {fmt(total)} <span style={{ fontSize: 15, fontWeight: 600, color: C.textMid }}>/ year</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        <MetricCard label="Employer Savings" value={empr} color={C.blue} bg={C.blueLight} testId="ibos-metric-employer" />
        <MetricCard label="Employee Value" value={emp} color={C.green} bg={C.greenLight} testId="ibos-metric-employee" />
        <MetricCard label="Healthcare Impact" value={hc} color={C.purple} bg={C.purpleLight} testId="ibos-metric-healthcare" />
      </div>
    </div>
  );
}

function MetricCard({ label, value, color, bg, testId }) {
  return (
    <div
      data-testid={testId}
      style={{
        background: bg,
        borderRadius: 10,
        padding: '14px 16px',
      }}
    >
      <div style={{ fontSize: 9, fontWeight: 700, color: C.textLight, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 4 }}>
        {label}
      </div>
      <div style={{ fontSize: 22, fontWeight: 800, color, fontFamily: "'JetBrains Mono', monospace" }}>
        {fmt(value)}
        <span style={{ fontSize: 11, fontWeight: 600, color: C.textMid, marginLeft: 4 }}>/yr</span>
      </div>
    </div>
  );
}
